module.exports = __webpack_public_path__ + "static/media/tlyfeImageText.a11628df.png";